<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4 *ngIf="request.source |isWorkorderRequest; else isServiceRequest1">{{'components.editRequest.workorderRequest' | translate}}</h4>
            <ng-template #isServiceRequest1>
                <h4>{{'components.editRequest.serviceRequest' | translate}}</h4>
            </ng-template>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12"><b>{{'components.editRequest.number' | translate}} {{request.requestNumber}}</b></div>
    </div>
    <hr class="separator" />
    <div class="row title">
        <div *ngIf="request.source |isWorkorderRequest; else isServiceRequest2" class="col-sm-12">{{'components.editRequest.workorderChosen' | translate}}</div>
        <ng-template #isServiceRequest2>
            <div class="col-sm-12">{{'components.editRequest.serviceRequestChosen' | translate}}</div>
        </ng-template>
    </div>
    <div class="row value">
        <div class="col-sm-12"><img class="srv-img" src="{{iconService.getIconName(request.service.code)}}" />
            <span>{{request.requestNumber}}</span>
            <span *ngIf="request.service"> - {{request.service.name}}</span>
            <span *ngIf="request.formattedAddress"> - {{request.formattedAddress}}</span>
        </div>
    </div>
    <div class="row title">
        <div class="col-sm-12">{{'components.editRequest.status' | translate}}</div>
    </div>
    <div class="row value">
        <div class="col-sm-12"><i class="fa fa-hourglass-half" aria-hidden="true"></i> {{request.status?.name}}</div>
    </div>

    <hr class="separator" />
    <div class="row">
        <h5><div class="col-sm-12"><b>{{'components.sheet.manager' | translate}} :</b></div></h5>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="row title">
                <div class="col-sm-12">{{'components.sheet.requestOrigin' | translate}}</div>
            </div>
            <div class="row value">
                <div class="col-sm-12"><i class="fa fa-user" aria-hidden="true"></i> {{request.responsible?.userName}}</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="row title">
                <div class="col-sm-12">{{'components.sheet.managerGroup' | translate}}</div>
            </div>
            <div class="row value">
                <div class="col-sm-12"><i class="fa fa-users" aria-hidden="true"></i> {{request.responsible?.groupName}}</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="row title">
                <div class="col-sm-12">{{'components.sheet.district' | translate}}</div>
            </div>
            <div class="row value">
                <div class="col-sm-12"><i class="fa fa-building" aria-hidden="true"></i> {{request.borough?.name}}</div>
            </div>
        </div>
    </div>


    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.takeInCharge)?.getSessionVisible() && !(request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.takeInCharge" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.takeInCharge)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.takeInCharge)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.takeInCharge)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list" [collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.takeInCharge)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.takeInCharge)?.getCollapsed()">
        </app-edit-form>
    </div>

    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.cancelTakeInCharge)?.getSessionVisible() && (request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.cancelTakeInCharge" | translate }}</div>
            <button button class="btnRound" [disabled]="(request |isInternalWorkorderRequest)" (click)="onCancelTakeInCharge()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
    </div>

    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.updateActivity)?.getSessionVisible()">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.updateActivity" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.updateActivity)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.updateActivity)?.getBtnDisabled() || !(request |canUpdateActivity)" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.updateActivity)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.updateActivity)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.updateActivity)?.getCollapsed()">
        </app-edit-form>
    </div>

    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.updateResponsible)?.getSessionVisible()">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.updateResponsible" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.updateResponsible)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.updateResponsible)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.updateResponsible)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.updateResponsible)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.updateResponsible)?.getCollapsed()">
        </app-edit-form>
    </div>

    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.closeWorkorder)?.getSessionVisible() && (request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.closeWorkorder" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.closeWorkorder)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.closeWorkorder)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.closeWorkorder)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.closeWorkorder)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.closeWorkorder)?.getCollapsed()">
        </app-edit-form>
    </div>

    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.changeStatus)?.getSessionVisible() && (request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.changeStatus" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.changeStatus)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.changeStatus)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.changeStatus)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.changeStatus)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.changeStatus)?.getCollapsed()">
        </app-edit-form>
    </div>
    
    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getSessionVisible() ">
        <hr class="separator" />
        <div class="row value">
            <div class="col-sm-3">{{'components.editRequest.returnDDS' | translate}}</div>
            <div class="col-sm-6 text-danger">
                <small *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getWarningMessage()">
          ( {{'components.editRequest.errors.'+editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getWarningMessage() | translate}} )
        </small>
            </div>
            <div class="col-sm-3">
                <button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.returnDDS)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getBtnVisible()">
          {{'components.editRequest.choose' | translate}}
        </button>
            </div>
        </div>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.returnDDS)?.getCollapsed()">
        </app-edit-form>
    </div>
    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)?.getSessionVisible() && (request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.addPhoto" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.addPhoto)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-photos-gallery [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)?.getCollapsed()" [cancelAction]="editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)" [afterSaveAction]="editRequestService.findCollapseItemByName(collapseItemsEnum.addPhoto)">
        </app-photos-gallery>
    </div>
    <div *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.addInternalComment)?.getSessionVisible() && (request.source |isWorkorderRequest)">
        <app-edit-request-template>
            <div column>{{ "components.editRequest.addInternalComment" | translate }}</div>
            <button button class="btnRound" (click)="editRequestService.toggleCollapse(collapseItemsEnum.addInternalComment)" [disabled]="editRequestService.findCollapseItemByName(collapseItemsEnum.addInternalComment)?.getBtnDisabled()" *ngIf="editRequestService.findCollapseItemByName(collapseItemsEnum.addInternalComment)?.getBtnVisible()">
                {{'components.editRequest.choose' | translate}}
              </button>
          </app-edit-request-template>
        <app-edit-form redirectRoute="/list"[collapseItem]="editRequestService.findCollapseItemByName(collapseItemsEnum.addInternalComment)" [request]="request" *ngIf="!editRequestService.findCollapseItemByName(collapseItemsEnum.addInternalComment)?.getCollapsed()">
        </app-edit-form>
    </div>
    <hr class="separator" />
    <div class="row value justify-content-center">
        <div class="col-sm-4 col-sm-offset-4">
            <button class="btnFilled" (click)="backToRequestList()">
        <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> {{'components.editRequest.back' | translate}}
      </button>
        </div>
    </div>
</div>